import * as React from 'react'
import { Button } from '@deepguide-ai/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@deepguide-ai/ui/dialog'
import { Input } from '@deepguide-ai/ui/input'
import { Label } from '@deepguide-ai/ui/label'

interface VideoDialogProps {
  isOpen: boolean
  onClose: () => void
  onSubmit: (url: string) => void
}

export function VideoDialog({ isOpen, onClose, onSubmit }: VideoDialogProps) {
  const [url, setUrl] = React.useState('')

  React.useEffect(() => {
    if (isOpen) setUrl('')
  }, [isOpen])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    const trimmedUrl = url.trim()
    if (trimmedUrl) onSubmit(trimmedUrl)
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <form onSubmit={handleSubmit}>
          <DialogHeader>
            <DialogTitle>Insert video from URL</DialogTitle>
            <DialogDescription>
              Paste a video URL, including YouTube links.
            </DialogDescription>
          </DialogHeader>

          <div className='space-y-2 px-6 py-5'>
            <Label htmlFor='tiptap-video-url'>Video URL</Label>
            <Input
              id='tiptap-video-url'
              value={url}
              onChange={(event) => setUrl(event.target.value)}
              placeholder='https://...'
              autoFocus
            />
          </div>

          <DialogFooter>
            <Button type='button' variant='outline' onClick={onClose}>
              Cancel
            </Button>
            <Button type='submit' disabled={!url.trim()}>
              Insert video
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  )
}
